export default function (condition: unknown, exprIfTrue: unknown, exprIfFalse: unknown): unknown {
    return condition ? exprIfTrue : exprIfFalse;
}
